module.exports = __webpack_public_path__ + "static/media/image_part_008.5f94fc12.jpg";